import React, { Component } from 'react';
import axios from 'axios';
import Helmet from 'react-helmet';

const initialState = {
    credentialId: '',
    credentialName: '',
    regDate: '',
    complete: false,
    errorMap: null,
    loading: false
}

class PasskeyDelete extends Component {
    state = initialState;

    componentDidMount() {

        // GA計測用データレイヤースクリプトを追加する
        window.addDataLayerScript('jmbauth_passkey_delete_confirmation');

        if (this.props.location.state.credentialId
            && this.props.location.state.credentialName
             && this.props.location.state.regDate) {
            this.setState({
                credentialId: this.props.location.state.credentialId,
                credentialName: this.props.location.state.credentialName,
                regDate: this.props.location.state.regDate
            });
        }
    }

    // 画面をクローズする
    delete = async () => {
        let messageList = JSON.parse(sessionStorage.getItem('messageList'));

        // Cookieからl_sidを取得する
        let l_sid = window.getCookieValue('l_sid');

        // アクショントークン格納変数の宣言
        let actionToken = null;

        // SDK呼出(アクションレポート)
        try {
            // アクションのレポート作成
            const actionPromise = window.tsPlatform.drs.triggerActionEvent("account_details_change_passkey_delete", { correlationId: l_sid });

            // タイムアウト判定関数
            const timeoutPromise = new Promise((_, reject) => {
                setTimeout(() => {
                    reject(new Error('Action token request timed out'));
                }, process.env.REACT_APP_TRIGGERACTIONEVENT_TIMEOUT); // envに設定されたタイムアウト時間(ミリ秒)を設定
            });

            // タイムアウト時間内にアクショントークンが取得できた場合、アクショントークン変数に設定
            const actionResponse = await Promise.race([actionPromise, timeoutPromise]);
            actionToken = actionResponse ? actionResponse.actionToken : null;
        } catch (e) {
            // タイムアウト時の処理
            if (e.message.includes('timed out')) {
                // エラー文言を、アクショントークン変数に設定
                actionToken = 'jallogin_transmit_api_timeout';
            }
        }

        // FIDO2クレデンシャル情報登録解除要求を行う
        try {
            // ローディング開始
            this.setState({ loading: true });

            // FIDO2クレデンシャル情報登録解除APIを呼出す
            axios({
                method: 'POST',
                url: process.env.REACT_APP_URL_CO_SC_API_CREDENTIAL_INFO_DEREGISTRATION,
                data: {
                    credentialId: [this.state.credentialId],
                },
                headers: {
                    'accept-language': window.changeLang(sessionStorage.getItem('lang')),
                    'Cache-Control': 'no-store',
                    'Pragma': 'no-cache'
                }
            })
                .then((response) => {
                    this.setState({
                        complete: true,
                        errorMap: null,
                        loading: false
                    });

                    // GA計測用データレイヤースクリプトを追加する
                    window.addDataLayerScript('jmbauth_passkey_delete_completion');
                })
                .catch(error => {
                    if (error.response) {
                        if (error.response.status === 400) {
                            this.setState({
                                errorMap: { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.passkeyDelete.M011_errorMessage001 },
                                loading: false
                            });
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }
                        else if (error.response.status === 401) {
                            this.setState({
                                errorMap: { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.passkeyDelete.M011_errorMessage001 },
                                loading: false
                            });
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }
                        else if (error.response.status === 500) {
                            if (error.response.data.errorCode === 'CO-FS2808' ) {
                                // CO-FS2808が返却された場合
                                this.setState({
                                    errorMap: { ERROR: error.response.data.errorMessage ? error.response.data.errorMessage : messageList.passkeyDelete.M011_errorMessage001 },
                                    loading: false
                                });
                                // エラーメッセージ表示領域に遷移する
                                window.location = "#JS_error";
                            } else {
                                // エラー画面に遷移し、処理を終了する
                                this.props.history.push({
                                    pathname: `${process.env.REACT_APP_CONTEXT_PATH}/error`
                                });
                            }
                        }
                        else {
                            this.setState({
                                errorMap: { ERROR: messageList.passkeyDelete.M011_errorMessage001 },
                                loading: false
                            });
                            // エラーメッセージ表示領域に遷移する
                            window.location = "#JS_error";
                        }
                    }
                    else {
                        this.setState({
                            errorMap: { ERROR: messageList.passkeyDelete.M011_errorMessage001 },
                            loading: false
                        });
                        // エラーメッセージ表示領域に遷移する
                        window.location = "#JS_error";
                    }
                })
        } catch (error) {
            this.setState({
                errorMap: { ERROR: messageList.passkeyDelete.M011_errorMessage001 },
                loading: false
            });
            // エラーメッセージ表示領域に遷移する
            window.location = "#JS_error";
        } finally {
        }
    }

    toPasskey = e => {
        window.location.href = `${process.env.REACT_APP_CONTEXT_PATH}/menu/fido/top?design=` + sessionStorage.getItem('design') + "&lang=" + sessionStorage.getItem('lang');
    }

    render() {

        // 文言リストを取得する
        let messageList = JSON.parse(sessionStorage.getItem('messageList'));

        // パスキー削除完了画面表示
        if (this.state.complete) {
            return (
                <section className="content">
                    <Helmet
                        title={messageList.passkeyDeleteCompletion.M001_browserTitle} >
                    </Helmet>

                    {/* 画面タイトル表示部 */}
                    <div className="ds-heading ds-heading--lg">
                        <h1 className="ds-heading__title">{messageList.passkeyDeleteCompletion.M002_pageTitle}</h1>
                    </div>

                    <div className="contentInner">
                        {/* 操作ボタン表示部 */}
                        <div className="buttonLayout">
                            <div className="buttonWrap buttonWrap--center">
                                {/* .ds-button */}
                                <div className="ds-button ds-button--tertiary ds-button--large">
                                    <button className="ds-button__trigger" type="button" onClick={this.toPasskey}>
                                        <span className="ds-button__label">{messageList.passkeyDeleteCompletion.M003_back}</span>
                                    </button>
                                </div>
                                {/* / .ds-button */}
                            </div>
                        </div>
                        {/* / .buttonLayout */}
                    </div>

                </section>
            );
        }

        // パスキー削除確認画面表示
        else {
            return (
                <section className="content">
                    <Helmet
                        title={messageList.passkeyDelete.M001_browserTitle} >
                    </Helmet>

                    { // Loadingモーダル表示
                        this.state.loading &&
                        <div id="loading" className="loading-modal"><img className="loading-img" src={`${process.env.PUBLIC_URL}/assets/img/load.gif`} alt="loading" /></div>
                    }

                    {/* 画面タイトル表示部 */}
                    <div className="ds-heading ds-heading--lg">
                        <h1 className="ds-heading__title">{messageList.passkeyDelete.M002_pageTitle}</h1>
                    </div>

                    <div className="contentInner">
                        <p className="ds-text">{messageList.passkeyDelete.M010_guideMessage001}</p>

                        <div id="JS_error">
                            { // エラーメッセージ表示
                                (this.state.errorMap && this.state.errorMap.ERROR) &&
                                <div className="ds-inlineNote ds-inlineNote--attention" role="alert" aria-live="assertive">
                                    <div className="ds-inlineNote__details">
                                        <div className="ds-inlineNote__summary">
                                            <h2 className="ds-inlineNote__heading">
                                                <span className="ds-inlineNote__headingIcon">
                                                    <svg className="ds-icon" width="30" height="30" role="img" aria-label={messageList.passkeyDelete.M003_errorIconText}>
                                                        <use href={`${process.env.PUBLIC_URL}/assets/img/icon_sprite.svg#icon_attention`}></use>
                                                    </svg>
                                                </span>
                                                <span className="ds-inlineNote__headingLabel">{messageList.passkeyDelete.M004_errorBoxTitle}</span>
                                            </h2>
                                        </div>
                                        <div className="ds-inlineNote__content">
                                            <p className="ds-text">{this.state.errorMap.ERROR}</p>
                                        </div>
                                    </div>
                                </div>/* /ds-inlineNote */
                            }
                        </div>

                        {/* .ds-heading */}
                        <div className="ds-heading ds-heading--sm">
                            <h2 className="ds-heading__title">{messageList.passkeyDelete.M005_pageTitleSub}</h2>
                        </div>
                        {/* / .ds-heading */}

                        {/* .ds-table */}
                        <div className="ds-table ds-table--simple">
                            <div className="ds-table__container ds-table__container--auto">
                                <table className="ds-table__table">
                                    <thead className="ds-table__head">
                                        <tr>
                                            <th scope="col">{messageList.passkeyDelete.M006_colname001}</th>
                                            <th scope="col">{messageList.passkeyDelete.M007_colname002}</th>
                                        </tr>
                                    </thead>
                                    <tbody className="ds-table__body">
                                        <tr>
                                            <td>{this.state.credentialName}</td>
                                            <td>{this.state.regDate}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {/* / .ds-table */}

                        {/* 操作ボタン表示部 */}
                        <div className="buttonLayout">
                            <div className="buttonWrap buttonWrap--center">
                                {/* .ds-button */}
                                <div className="ds-button ds-button--primary ds-button--large">
                                    <button className="ds-button__trigger" type="button" onClick={this.delete}>
                                        <span className="ds-button__label">{messageList.passkeyDelete.M008_delete}</span>
                                    </button>
                                </div>
                                {/* / .ds-button */}
                            </div>
                            <div className="buttonWrap buttonWrap--left">
                                {/* .ds-button */}
                                <div className="ds-button ds-button--tertiary ds-button--large">
                                    <button className="ds-button__trigger" type="button" onClick={this.toPasskey}>
                                        <span className="ds-button__label">{messageList.passkeyDelete.M009_back}</span>
                                    </button>
                                </div>
                                {/* / .ds-button */}
                            </div>
                        </div>
                        {/* / .buttonLayout */}
                    </div>

                </section>
            );
        }

    }
}

export default PasskeyDelete
